import React, { Component} from 'react';
import Header from './components/Header/Header';
import HeroSection from './components/HeroSection/HeroSection';
import ContentSection from './components/ContentSection/ContentSection';
import FullWidthImg from './components/FullWidthImg/FullWidthImg';
import Footer from './components/Footer/Footer';
import './App.css';

class App extends Component{
	render(){
		return (
			<div className ="App">
				<Header></Header>
				<div className="main_container">
					<HeroSection></HeroSection>				
					<ContentSection secID="0"></ContentSection>
					<FullWidthImg bgID="first"></FullWidthImg>
					<ContentSection secID="1"></ContentSection>
					<FullWidthImg bgID="second"></FullWidthImg>
					<ContentSection secID="2"></ContentSection>
					<Footer></Footer>
				</div>
			</div>
		)
	}  
}

export default App;